import React from 'react';

function Terms(props) {

  return (
    <div className="page">
      <div className="text_block_white">
        <h3>Terms of Use</h3>
        <p><strong>Last updated:</strong> July 3, 2026</p>

        <p>
          These Terms of Use apply to your use of the Last Mountain Wireless
          website and to communications with Last Mountain Wireless Inc. These
          terms are intended to provide general website and messaging terms.
          Service plans, installation work, billing arrangements, and customer
          accounts may be subject to additional terms provided separately.
        </p>

        <h5>Use of our website</h5>
        <p>
          You may use this website to learn about our services, check
          availability, contact us, and request information. You agree not to
          misuse the website, interfere with its operation, attempt unauthorized
          access, or use it for unlawful purposes.
        </p>

        <h5>Availability, plans, and pricing</h5>
        <p>
          Information on this website is provided for general information.
          Service availability, plan options, installation requirements, speeds,
          and pricing may depend on your location, equipment, network
          conditions, and other factors. We may update website information,
          pricing, and service offerings from time to time.
        </p>

        <h5>Text message terms</h5>
        <p>
          I agree to receive recurring automated text messages at the phone
          number provided. Msg & data rates may apply. Msg frequency varies.
          Reply HELP for help and STOP to cancel. View our
          <a className="black_link" href="/terms"> Terms of Service</a> and
          <a className="black_link" href="/privacy"> Privacy Policy</a>.
        </p>
        <p>
          By providing your mobile phone number and opting in to receive text
          messages from Last Mountain Wireless, you agree that we may send SMS
          or MMS messages to the phone number you provided. Messages may include
          customer care replies, account notifications, installation or
          appointment reminders, service updates, outage or troubleshooting
          messages, payment confirmations, and service-related offers where you
          have agreed to receive them.
        </p>
        <p>
          Message frequency varies based on your account, service activity, and
          requests. Message and data rates may apply. Consent to receive
          marketing text messages is not required to purchase service from Last
          Mountain Wireless.
        </p>
        <p>
          You may opt out of text messages at any time by replying STOP to any
          message from us. After you send STOP, we may send one confirmation
          message and then stop sending text messages to that number, unless you
          opt in again or we are otherwise permitted or required to contact you.
          For help, reply HELP or contact us at
          <a className="black_link" href="tel://13069004321"> 1.306.900.4321</a>
          {' '}or <a className="black_link" href="mailto:info@lmw.email">info@lmw.email</a>.
        </p>
        <p>
          Mobile carriers are not liable for delayed or undelivered messages.
          Delivery of text messages may depend on your carrier, device, and
          network availability.
        </p>

        <h5>Privacy</h5>
        <p>
          Our use of personal information is described in our
          <a className="black_link" href="/privacy"> Privacy Policy</a>. The
          Privacy Policy includes additional information about text messaging
          consent and mobile information.
        </p>

        <h5>No warranties</h5>
        <p>
          The website is provided on an as-is and as-available basis. We try to
          keep information accurate and current, but we do not guarantee that
          the website will always be available, error-free, or complete.
        </p>

        <h5>Limitation of liability</h5>
        <p>
          To the extent permitted by law, Last Mountain Wireless Inc. is not
          responsible for indirect, incidental, special, or consequential
          damages arising from use of this website or from delayed, unavailable,
          or undelivered communications.
        </p>

        <h5>Changes to these terms</h5>
        <p>
          We may update these terms from time to time. The updated version will
          be posted on this page with a new last updated date.
        </p>

        <h5>Contact us</h5>
        <p>
          Last Mountain Wireless Inc.<br/>
          Box #8, Govan, SK S0G 1Z0<br/>
          Phone or text: <a className="black_link" href="tel://13069004321">1.306.900.4321</a><br/>
          Email: <a className="black_link" href="mailto:info@lmw.email">info@lmw.email</a>
        </p>
      </div>

    </div>);

}

export default Terms;
